module.exports = require("core-js/library/fn/object/get-own-property-symbols");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/object/get-own-property-symbols.js